import Connection from "../utils/Connection";
import { EXPRESS_URL } from "../utils/Macros";

export async function getQuestionsCountInTheme(themeID: string) { 
    return await Connection.get(`${EXPRESS_URL}themes/count-quest/${themeID}`);
}

export async function getQuestionsCountInThemeMulti(data: string) { 
    return await Connection.get(`${EXPRESS_URL}themes/count-quest-multi/${data}`);
}